import { type ReactNode } from "react";
import { DashboardSection } from "@/components/dashboard-section";
import { PageHeader } from "@/components/page-header";
import { CoolIcon } from "@/components/ui/cool-icon";

/**
 * Compound Tracker — placeholder until the extractions write path lands.
 *
 * The previous version rendered fabricated growth/extraction/reinvestment
 * numbers (Nov 2025 → Apr 2026) which would be misleading the moment a
 * real account is connected. Per the data audit, no code path INSERTs
 * into the `extractions` table yet, so there's nothing real to display.
 *
 * When the extraction writer + reinvestment loop ship, restore the
 * previous AreaChart + monthly cards + TradingCalendar against real
 * data — the layout was good, the numbers were the problem.
 */
export function CompoundPage(): ReactNode {
  return (
    <div className="flex flex-col gap-5">
      <PageHeader
        title="Compound Tracker"
        subtitle="Reinvestment Progress & Harvest Income"
        icon={<CoolIcon name="Trending_Up" />}
        accentWords={["Compound"]}
      />

      <DashboardSection>
        <div className="flex flex-col items-center gap-3 py-16 text-center">
          <div className="flex h-12 w-12 items-center justify-center rounded-full bg-accent/10 text-2xl text-accent">
            <CoolIcon name="Star" />
          </div>
          <div>
            <h2 className="text-base font-semibold tracking-tight">
              Activates After Your First Extraction
            </h2>
            <p className="mx-auto mt-2 max-w-md text-sm text-muted-foreground">
              The compound tracker plots your batch funnel (8 → 4 → 2 accounts)
              and shows how much profit you've extracted vs. reinvested each
              month. It lights up the moment your first prop-firm payout lands.
            </p>
          </div>
        </div>
      </DashboardSection>
    </div>
  );
}
